module.exports = __webpack_public_path__ + "static/media/express-icon.d3501596.png";